import { push as router_push, replace as router_replace, goBack } from 'react-router-redux'

export const push = (routeName, options) => {
    return (dispatch) => {
        dispatch(router_push({ pathname: routeName, ...options }))
    };
}

export const replace = (routeName) => {
    return (dispatch) => {
        dispatch(router_replace(routeName));
    }
}

export const back = () => {
    return (dispatch) => {
        dispatch(goBack());
    }
}


// WEBPACK FOOTER //
// ./src/actions/nav-actions.js